import styled from "styled-components";
import { COLORS, SIZES, WEIGHT } from "../../components/layout/theme";
import { Steps } from "antd";

export const Inner = styled.div`
	background-color: ${COLORS.LightGrey};
	padding: 30px 70px;
	${(props) =>
		props.isMobile
			? `
    padding: 20px 30px;
  `
			: `
    padding: 30px 70px;
  `}
	@media only screen and (min-width: 1191px) and (max-width: 1284px) {
		padding: 30px 5px;
	}

	@media only screen and (min-width: 1285px) and (max-width: 1393px) {
		padding: 30px 30px;
	}
`;

export const Body = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;

	& .noBackground,
	& .noBackground:hover {
		background-color: ${COLORS.LightGrey} !important;
		border: none;
	}
`;

export const StepsContainer = styled.div`
	margin: 1rem;
	background-color: white;
	border-radius: 40px;
	${(props) =>
		props.isMobile
			? `
    width: 100%;
  `
			: `
    width: 70%;
  `}
	${(props) =>
		props.isMobile
			? `
    margin: 0rem;;
  `
			: `
    margin: 1rem;;
  `}
`;

export const AntdSteps = styled(Steps)`
	padding: 10px 20px 10px 20px;

	.ant-steps-item-content {
		background-color: ${COLORS.White};
	}

	.ant-steps-item-title::after {
		position: absolute;
		top: 16px;
		left: 130px;
		display: block;
		width: 1250px;
		height: 2px;
		background: #f0f0f0;
		content: "";
	}

	&.ant-steps-item-active {
		.ant-steps-item-container {
			.ant-steps-item-content {
				.ant-steps-item-title {
					color: ${COLORS.Primary};
				}
				.ant-steps-item-icon {
					color: ${COLORS.Primary};
				}
			}
		}
	}

	.ant-steps-item-process
		> .ant-steps-item-container
		> .ant-steps-item-content
		> .ant-steps-item-title {
		color: ${COLORS.Primary};
		width: 120px;
		border: 1px solid ${COLORS.White};
		border-radius: 5px;
	}

	.ant-steps-item-finish {
		.ant-steps-item-container {
			.ant-steps-item-content {
				.ant-steps-item-title {
					color: ${COLORS.Grey};
				}
			}
		}
	}

	&.ant-steps
		.ant-steps-item:not(.ant-steps-item-active)
		> .ant-steps-item-container[role="button"]
		.ant-steps-item-icon
		.ant-steps-icon {
		display: flex;
		margin-right: 10px;
	}

	.ant-steps-item-custom.ant-steps-item-process
		.ant-steps-item-icon
		> .ant-steps-icon {
		display: flex;
		margin-right: 10px;
	}

	.ant-steps-item-finish
		> .ant-steps-item-container
		> .ant-steps-item-content
		> .ant-steps-item-title::after {
		background-color: ${COLORS.Success};
	}

	.ant-steps-item-wait
		> .ant-steps-item-container
		> .ant-steps-item-content
		> .ant-steps-item-title {
		width: 120px;
		border: 1px solid ${COLORS.White};
		border-radius: 5px;
	}

	.ant-steps-item-finish
		.ant-steps-item-container
		.ant-steps-item-content
		.ant-steps-item-title {
		width: 120px;
		border: 1px solid ${COLORS.White};
		border-radius: 10px;
	}

	@media only screen and (min-width: 760px) and (max-width: 881px) {
		padding: 20px 30px 20px 30px;
	}

	@media only screen and (min-width: 882px) and (max-width: 979px) {
		padding: 20px 80px 20px 80px;
	}

	@media only screen and (min-width: 980px) and (max-width: 1076px) {
		padding: 20px 100px 20px 100px;
	}

	@media only screen and (min-width: 1075px) and (max-width: 1189px) {
		padding: 20px 120px 20px 120px;
	}
`;

export const Container = styled.div`
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	width: 110px;
`;

export const IconContainer = styled.img`
	align-items: center;
	display: flex;
	justify-content: center;
	object-fit: contain;
	width: 25px;
	height: auto;
`;

export const TitleContainer = styled.div`
	${(props) =>
		props.color &&
		`
    color: ${props.color};
  `} font-size: ${SIZES.level5};
	font-weight: ${WEIGHT.Bold};
	white-space: nowrap;
`;
